import moment from 'moment'
import {
  fetchPricingPlans,
  fetchActionsBlock,
  getPlanPrice,
} from './billing.ts'

export const initializePendo = async user => {
  const org =
    user?.Organizations?.filter(org => org.active)?.[0] ||
    user?.Organizations?.[0]

  let account = {}

  const plans = await fetchPricingPlans()
  const hasBlockedActions = await fetchActionsBlock(org.id)

  const planPrice = getPlanPrice(org.planType, plans, org.billingCycle)

  const monthly_value =
    org.billingCycle === 'yearly' ? planPrice / 12 : planPrice

  const currentDate = new Date()
  const billingDay = new Date(org.billingStartDate).getDate()

  currentDate.setDate(billingDay)

  const cycleResetDate = moment(currentDate).add(1, 'M').format()

  if (org) {
    account = {
      id: org.id,
      name: org.name,
      is_paying: org.active,
      monthly_value,
      hasBlockedActions,
      planLevel: org.planType,
      planPrice,
      creationDate: org.createdAt,
      cycleReset: cycleResetDate,
    }
  }

  const deviceType = window.innerWidth < 800 ? 'mobile' : 'desktop'

  const values = {
    account,
    visitor: {
      deviceType,
      id: user.id,
      email: user.email,
      role: user.admin ? 'admin' : 'user',
      screenWidth: window.innerWidth,
      persona: user.persona,
    },
  }

  if (process.env.NODE_ENV === 'production') {
    window.pendo.initialize(values)
  }
}
